import { PartnerType } from 'legacy/lut/classes/models/PartnerType'

import { Nullable } from 'clickNgo/models/utils'

import { dataForCommercials, dataForDistributors } from '../config'

export const getData = (partnersType: Nullable<PartnerType>) => {
  if (partnersType === PartnerType.Distributor) {
    return dataForDistributors
  }

  return dataForCommercials
}
